import { formatDate, TimeOffRequestExtended, TimeOffRequestStatus, TimeOffRequestStatusLabels } from "winslow-core";
import "./AppEmployeeTimeOffRequestCard.css";
import  { daysIncluded } from "winslow-core";
import { CalendarClock } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { toastFail } from "../../../config";
import toast from "react-hot-toast";

const STATUS_COLORS = {
    [TimeOffRequestStatus.PENDING]: "yellow",
    [TimeOffRequestStatus.APPROVED]: "green",
    [TimeOffRequestStatus.REJECTED]: "red",
    [TimeOffRequestStatus.CANCELLED]: "dark-gray",
}

const STATUS_LABELS = {
    [TimeOffRequestStatus.PENDING]: "Pending",
    [TimeOffRequestStatus.APPROVED]: "Approved",
    [TimeOffRequestStatus.REJECTED]: "Rejected",
    [TimeOffRequestStatus.CANCELLED]: "Cancelled",
}

type AppEmployeeTimeOffRequestCardProps = {
    timeOffRequest: TimeOffRequestExtended;
}

export const AppEmployeeTimeOffRequestCard = ({ timeOffRequest }: AppEmployeeTimeOffRequestCardProps) => {

    const navigate = useNavigate();
    const torDays = daysIncluded(timeOffRequest.startDate, timeOffRequest.endDate);

    const handleEdit = () => {
        if (timeOffRequest.status === TimeOffRequestStatus.REJECTED) {
            toast("You cannot edit a rejected request. Submit a new one.", toastFail);
            return;
        }

        navigate("/app/employee/time-off/request/" + timeOffRequest.id);
    }

    return (
        <div 
            className="app-employee-time-off-request-card"
            onClick={handleEdit}
        >
            <div className="app-employee-time-off-request-card-icon">
                <CalendarClock size={24}/>
            </div>
            <div className="app-employee-time-off-request-card-info">
                <div className="app-employee-time-off-request-card-header">
                    {formatDate(new Date(timeOffRequest.startDate))} - {formatDate(new Date(timeOffRequest.endDate))}
                </div>
                <div className="app-employee-time-off-request-card-content">
                    <div className="app-employee-time-off-request-card-content-item">
                        {torDays} day on {timeOffRequest.paidTimeOffPolicy.name}
                    </div>

                    {/* <div className="app-employee-time-off-request-card-content-item">
                        {timeOffRequest.notes}
                    </div> */}
                </div>
            </div>
            <div className="app-employee-time-off-request-card-status">
                <div 
                    className="app-employee-time-off-request-status"
                    style={{ backgroundColor: STATUS_COLORS[timeOffRequest.status] }}
                >
                        {TimeOffRequestStatusLabels[timeOffRequest.status]}
                </div> 
            </div>
           
        </div>
    );
}